import io from "socket.io-client";
import MessagingSocketService from "../messaging_socket_service";
import { API_BASE_URL } from "../../../../core/constants/app_constants";
import { MessagingDataType } from "../../../domain/enum/messaging_data_type";

class MessagingSocketServiceImpl extends MessagingSocketService {
  static #instance = null; // Private static instance

  constructor() {
    if (MessagingSocketServiceImpl.#instance) {
      return MessagingSocketServiceImpl.#instance; // Return existing instance
    }
    super();
    MessagingSocketServiceImpl.#instance = this; // Store instance
    this.userId = null;
    this.chatChannelId = null;
    this.avatarId = null;
    this.messagingSocket = null;
  }

  connect({ userId, chatChannelId, avatarId, aiStatusCallback, aiResponseCallback, errorCallback, messageStatusCallback }) {
    if (this.messagingSocket) {
      console.log("Socket already exists");
      return;
    }

    this.userId = userId;
    this.chatChannelId = chatChannelId;
    this.avatarId = avatarId;

    console.log("MessagingSocketServiceImpl connect");

    this.messagingSocket = io(`${API_BASE_URL}/messaging`, {
      path: "/socket.io",
      query: {},
    });

    this.messagingSocket.on("connect", () => {
      console.log("Connected to /voice-call namespace with id:", this.messagingSocket.id);

      // Send Initial Data to Server
      this.messagingSocket.emit("data", {
        type: MessagingDataType.InitialData,
        data: {
          userId: this.userId,
          chatChannelId: this.chatChannelId,
          avatarId: this.avatarId,
        },
      });
    });

    this.messagingSocket.on("ai_status_notice", (payload) => {
      const { status } = payload;
      aiStatusCallback(status);
    });

    this.messagingSocket.on("message_status_notice", (payload) => {
      const { type, uniqueKey, status } = payload;
      messageStatusCallback(uniqueKey, status);
    });

    this.messagingSocket.on("data_notice", (payload) => {
      const { type, data } = payload;
      switch (type) {
        case MessagingDataType.AIResponse:
          aiResponseCallback(data);
          break;
        default:
          break;
      }
    });

    this.messagingSocket.on("error_notice", (payload) => {
      errorCallback(payload);
    });

    this.messagingSocket.on("disconnect", () => {
      console.log("Disconnected from /messaging namespace");
    });
  }

  sendMessage({ message, uniqueKey }) {
    if (this.messagingSocket) {
      console.log("SENDING", message);
      this.messagingSocket.emit("data", {
        type: MessagingDataType.UserMessage,
        data: {
          message: message,
          uniqueKey: uniqueKey,
        },
      });
    }
  }

  disconnect() {
    console.log("MessagingSocketServiceImpl disconnect");
    if (this.messagingSocket) {
      this.messagingSocket.disconnect();
      this.messagingSocket = null;
      this.userId = null;
      this.chatChannelId = null;
      this.avatarId = null;
    }
  }
}

export default MessagingSocketServiceImpl;
